exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".read{display:none}.unread{color:#f96f2b}.user_resting{width:282px;text-align:center}.user_resting .user_rest_image{max-width:30%;margin-top:60px}", ""]);

// exports
